(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-grid-manual"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wraps = document.querySelectorAll('[data-nsmg-video]');
    if (!wraps.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = Boolean(navigator.connection && navigator.connection.saveData);

    const start = (video) => {
      if (!video.dataset.nsmgReady) {
        for (const source of video.querySelectorAll('source[data-src]')) {
          source.src = source.dataset.src;
        }
        video.dataset.nsmgReady = 'true';
        video.load();
      }
      if (reduceMotion || saveData) return;
      video.play().catch(() => {});
    };

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting) {
          start(video);
        } else if (!video.paused) {
          video.pause();
        }
      }
    }, { rootMargin: '150px 0px', threshold: 0.15 });

    for (const wrap of wraps) {
      const video = wrap.querySelector('video');
      if (!video) continue;
      video.muted = true;
      observer.observe(video);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutry-black-month"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      for (const el of document.querySelectorAll('[data-nbm-countdown]')) {
        const end = Date.parse(el.dataset.end);
        if (Number.isNaN(end)) continue;
        const left = end - Date.now();
        if (left <= 0) {
          el.textContent = el.dataset.done;
          continue;
        }
        const d = Math.floor(left / 86400000);
        const h = Math.floor((left % 86400000) / 3600000);
        const m = Math.floor((left % 3600000) / 60000);
        el.textContent = `${el.dataset.label} · faltam ${d > 0 ? d + 'd ' : ''}${pad(h)}h ${pad(m)}m`;
      }
    };
    tick();
    setInterval(tick, 30000);

    const sticky = document.querySelector('[data-nbm-sticky]');
    const hero = document.querySelector('.nbm-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting;
      }).observe(hero);
    }

    // Ao voltar atrás, o browser mostra a página guardada com o botão ainda "a carregar": desbloqueia-os.
    window.addEventListener('pageshow', () => {
      for (const b of document.querySelectorAll('.nbm-btn[aria-busy]')) b.removeAttribute('aria-busy');
    });

    // Aplica o código sem tirar os que já estão a dar desconto (os códigos são combináveis).
    // A Shopify aceita no máximo 5 códigos, e os que ainda não se aplicam a nenhum produto também contam:
    // para o novo código entrar, saem primeiro os que não estão a dar desconto, do mais antigo para o mais recente.
    const MAX_CODES = 5;
    const addCode = async (code) => {
      const cart = await (await fetch('/cart.js')).json();
      const list = cart.discount_codes || [];
      if (list.some((c) => c.code.toUpperCase() === code.toUpperCase())) return;
      const applied = list.filter((c) => c.applicable).map((c) => c.code);
      const pending = list.filter((c) => !c.applicable).map((c) => c.code);
      while (applied.length + pending.length + 1 > MAX_CODES && pending.length) pending.shift();
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: [...applied, ...pending, code].join(',') }),
      });
      if (!res.ok) throw new Error('discount');
    };

    // Cartões de marca (OstroVit, Dietmed, Naturmil, pastas): a página do produto mostra "CÓDIGO ativo" com a frase
    // da oferta nos produtos abrangidos pelo código (ver nutry-bm-product-note).
    const rememberBrand = (btn) => {
      if (!btn.hasAttribute('data-nbm-brand')) return;
      try {
        sessionStorage.setItem(`nbm-brand:${btn.dataset.nbmCode.toUpperCase()}`, '1');
      } catch (e) {}
    };

    // Foto e título do cartão: aplicam o código e guardam a oferta (como o botão) e depois abrem a página do produto,
    // para lá aparecer "CÓDIGO ativo". Sem JS seguem o link normal /discount/CÓDIGO?redirect=produto.
    document.addEventListener('click', async (event) => {
      const link = event.target.closest('.nbm-card a:not(.nbm-btn)');
      const btn = link?.closest('.nbm-card')?.querySelector('.nbm-btn[data-nbm-code]');
      if (!btn || !btn.dataset.nbmTarget) return;
      event.preventDefault();
      try {
        await addCode(btn.dataset.nbmCode);
        rememberBrand(btn);
        if (btn.dataset.nbmHandle && btn.dataset.nbmPrice) {
          try {
            sessionStorage.setItem(`nbm-offer:${btn.dataset.nbmHandle}`, JSON.stringify({ code: btn.dataset.nbmCode, price: btn.dataset.nbmPrice }));
          } catch (e) {}
        }
        window.location.href = btn.dataset.nbmTarget;
      } catch (error) {
        window.location.href = link.href;
      }
    });

    document.addEventListener('click', async (event) => {
      const btn = event.target.closest('.nbm-btn[data-nbm-code], .nbm-btn[data-nbm-qty]');
      if (!btn) return;
      event.preventDefault();
      btn.setAttribute('aria-busy', 'true');
      try {
        const drawer = document.querySelector('cart-drawer');
        if (btn.dataset.nbmQty) {
          // O código entra primeiro, para a gaveta já abrir com o desconto aplicado
          if (btn.dataset.nbmCode) await addCode(btn.dataset.nbmCode);
          const body = { items: [{ id: Number(btn.dataset.nbmVariant), quantity: Number(btn.dataset.nbmQty) }] };
          if (drawer) {
            body.sections = `cart-icon-bubble,${drawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
            body.sections_url = window.location.pathname;
          }
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });
          if (!res.ok) throw new Error('add');
          const data = await res.json();
          if (drawer && data.sections) {
            // Abre a gaveta do carrinho do tema (como o botão normal de adicionar), em vez de ir para /cart
            drawer.renderContents(data);
            btn.removeAttribute('aria-busy');
            return;
          }
          window.location.href = '/cart';
          return;
        }
        if (btn.dataset.nbmCode) await addCode(btn.dataset.nbmCode);
        rememberBrand(btn);
        // A página do produto mostra "código aplicado" só a quem veio deste botão (ver nutry-bm-product-note)
        if (btn.dataset.nbmHandle && btn.dataset.nbmPrice) {
          try {
            sessionStorage.setItem(`nbm-offer:${btn.dataset.nbmHandle}`, JSON.stringify({ code: btn.dataset.nbmCode, price: btn.dataset.nbmPrice }));
          } catch (e) {}
        }
        window.location.href = btn.dataset.nbmTarget;
      } catch (error) {
        window.location.href = btn.href;
      }
    });

    // Botões dos emails (?abrir_carrinho=1): o produto e o código já entraram no carrinho, falta só abrir a gaveta.
    // O parâmetro sai do endereço para a gaveta não voltar a abrir ao recarregar a página (os UTM ficam).
    const pageUrl = new URL(window.location.href);
    if (pageUrl.searchParams.has('abrir_carrinho')) {
      pageUrl.searchParams.delete('abrir_carrinho');
      window.history.replaceState(window.history.state, '', pageUrl);
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        // Os estilos da gaveta só carregam depois da página: espera por eles (2 s no máximo) para não abrir sem estilo.
        const pending = [...document.querySelectorAll('link[href*="cart-items"], link[href*="nutry-cart"]')].filter((l) => l.media === 'print');
        const stylesReady = Promise.all(pending.map((l) => new Promise((resolve) => l.addEventListener('load', resolve, { once: true }))));
        const maxWait = new Promise((resolve) => setTimeout(resolve, 2000));
        customElements.whenDefined('cart-drawer').then(() => Promise.race([stylesReady, maxWait])).then(() => drawer.open());
      } else {
        window.location.href = '/cart';
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutry-bm-vip-thanks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'bmvip_reg';
    var MAX_AGE = 30 * 60 * 1000;

    function readReg() {
      try {
        var raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        var reg = JSON.parse(raw);
        if (!reg || !reg.t || Date.now() - reg.t > MAX_AGE) return null;
        return reg;
      } catch (e) { return null; }
    }

    function save(reg) {
      try { sessionStorage.setItem(KEY, JSON.stringify(reg)); } catch (e) {}
    }

    // GA4, dataLayer e Shopify: enviados logo ao abrir a página.
    function trackOthers(reg) {
      if (reg.others) return;
      var landing = reg.landing || '';
      try { if (window.gtag) window.gtag('event', 'generate_lead', { form_name: 'black_month_vip', landing: landing }); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'bm_vip_lead', landing: landing }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bm_vip_lead', { landing: landing }); } catch (e) {}
      reg.others = true;
      save(reg);
    }

    // Meta: o pixel pode só carregar depois de a pessoa responder ao aviso de cookies, por isso espera
    // até 60 s e só dá o registo por feito quando o evento é mesmo enviado.
    function trackMeta(reg) {
      if (reg.tracked) return;
      var landing = reg.landing || '';
      var eventId = reg.id || ('bmvip-' + reg.t);
      var waited = 0;
      (function tick() {
        if (window.fbq) {
          try {
            window.fbq('track', 'CompleteRegistration', { content_name: 'Black Month VIP', content_category: landing, status: true }, { eventID: eventId + '-cr' });
          } catch (e) {}
          reg.tracked = true;
          save(reg);
          return;
        }
        if (waited >= 60000) return;
        waited += 250;
        setTimeout(tick, 250);
      })();
    }

    function bindGoal(root, reg) {
      var box = root.querySelector('[data-bmvt-goal]');
      var action = root.getAttribute('data-ml-action');
      if (!box || !action || !reg.email) return;
      box.hidden = false;
      var ok = box.querySelector('[data-bmvt-goal-ok]');
      box.querySelectorAll('[data-goal]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          box.querySelectorAll('[data-goal]').forEach(function (c) {
            c.classList.toggle('is-on', c === chip);
            c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          });
          var data = new FormData();
          data.append('fields[email]', reg.email);
          data.append('fields[objetivo]', chip.getAttribute('data-goal'));
          data.append('ml-submit', '1');
          data.append('anticsrf', 'true');
          fetch(action, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
            .catch(function () {})
            .then(function () { if (ok) ok.hidden = false; });
        });
      });
    }

    function boot() {
      var root = document.querySelector('[data-bmvt]');
      if (!root || root.hasAttribute('data-bmvt-ready')) return;
      root.setAttribute('data-bmvt-ready', '');
      if (window.Shopify && Shopify.designMode) return;
      var reg = readReg();
      if (!reg) return;
      trackOthers(reg);
      trackMeta(reg);
      bindGoal(root, reg);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutry-bm-vip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Esconde o botão fixo do telemóvel enquanto o formulário ou a chamada final estão visíveis.
    function bind(root) {
      if (root.hasAttribute('data-bmv-ready')) return;
      root.setAttribute('data-bmv-ready', '');
      var bar = root.querySelector('[data-bmv-sticky]');
      if (!bar || !('IntersectionObserver' in window)) return;
      var targets = root.querySelectorAll('.bmv-card, .bmv-final');
      var state = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { state.set(e.target, e.isIntersecting); });
        var visible = false;
        state.forEach(function (v) { if (v) visible = true; });
        bar.classList.toggle('is-hidden', visible);
      });
      targets.forEach(function (t) { io.observe(t); });
    }
    function boot() { document.querySelectorAll('[data-bmv]').forEach(bind); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
